module.exports = __webpack_public_path__ + "img/DkIu.4ad0aa22.svg";